<template>
  <div v-loading="loading">
    <div class="info-wrapper">
      <div class="back" @click="$router.push('/exam/gaokao')">
        <img src="~images/back.png" width="10" />
        <span>返回</span>
      </div>

      <div class="info">
        <h4>{{ examName }}</h4>

        <div class="subject-list">
          <div class="tool-subject" v-for="(sub, index) in subjectNames" :key="index">
            <span>{{ sub.slice(0, 1) }}</span>
          </div>
        </div>

        <div class="date">
          <img src="~images/time.png" width="16" />
          <label>{{ examDate }}</label>
        </div>
      </div>

      <div v-if="isRegion === false" class="setting" @click="pathToSetting">
        <img src="~images/setting.png" />
      </div>
    </div>

    <header class="header">
      <div class="report-button">
        <router-link v-for="(item, index) in routerKinds" v-authvalidate="item.auth" :key="'route' + index" tag="a" class="menu-tab" :class="{ actived: $route.path.indexOf(item.parentPath || item.path) >= 0 }" :to="getRoute(item)">
          {{ item.label }}
        </router-link>
      </div>
      <div style="flex: 1;"></div>

      <!--单科校级报告导出-->
      <div v-if="!isRegion" class="export-report">
        <div>
          <div class="top" @click="exportData()">
            <img src="~images/export_report.png" width="24" />
            <span>导出报表</span>
          </div>
          <div style="height:18px;clear:both"></div>
        </div>
      </div>
    </header>

    <div class="main" v-if="!loading">
      <router-view :grade-id="gradeId" :is-more="isMore" :is-split="isSplit" :subject-list="subjectList" :school-id="userInfo.schoolId" />
    </div>

    <export-modal :reportList="reportList" :school-all-report="schoolAllReport" :showSixRete="false" @click-item="clickItem" ref="exportModal"> </export-modal>
  </div>
</template>

<script>
import { getLevelExam } from "@/api/exam/levelExam";
import Util from "@/utils/util";
import { mapGetters } from 'vuex'
import exam_enum from "@/utils/exam_enum";
import { xGaokao } from '@/utils/gaokao'
import ExportModal from "@/v2/views/components/ExportModal"
import { reportApi } from "@/v2/utils/api";
import { reportData } from '@/v2/utils/data'

export default {
  components: {
    ExportModal
  },

  data () {
    return {
      pathArray: [],
      loading: true,
      includeRoutes: [],
      examId: this.$route.params.id,
      examLoading: true,
      examName: "",
      examDate: "",
      gradeId: "",
      isMore: '',
      isSplit: 0,
      subjectNames: [],
      subjectList: [],
      examType: 0,
      examLineType: 0,
      routerKinds: [],
      reportList: [],
      schoolAllReport: {},
      summaryConfig: reportData.getQueryItems('高考汇总').list,
      mainConfig: reportData.getQueryItems('高考主科').list,
      scienceConfig: reportData.getQueryItems('高考物理').list,
      artConfig: reportData.getQueryItems('高考历史').list,
    };
  },
  computed: {
    ...mapGetters({
      userInfo: 'getUserInfo'
    }),
    isRegion () {
      return this.$route.query.isRegion + '' === 'true'
    },
    categoryKey () {
      let key = 'summary'
      const path = this.$route.path
      if (path.includes('subject')) {
        key = 'main'
      } else if (path.includes('like')) {
        key = 'science'
      } else if (path.includes('wenke')) {
        key = 'art'
      }
      return key
    },
    categoryType () {
      return `SCHOOL_NCEE_${this.categoryKey.toUpperCase()}_REPORT_ZIP`
    }
  },

  async mounted () {
    this.setRouteKinds()
    await this._getExam();
    this.initWaterMark();
    // 跳转第一个路由
    if (this.routerKinds.length) {
      let kindRoute = this.routerKinds[0]
      if (this.reportType) {
        const target = this.routerKinds.find(item => item.reportType === parseInt(this.reportType))
        if (target) {
          kindRoute = target
        }
      }
      const route = this.getRoute(kindRoute)
      this.$router.replace(route)
    }
  },
  beforeRouteLeave (to, from, next) {
    watermark.load({ show: false });
    watermark.remove();
    next();
  },
  methods: {
    clickItem: function (info) {
      this[info.method](info.params)
    },
    setRouteKinds () {
      const list = []
      if (this.$route.query.newFlag + '' === 'false') {
        list.push({
          reportType: 0,
          path: '/summary',
          label: '汇总报告',
          auth: 'Exam-Gaokao-Report-Summary'
        })
        list.push({
          reportType: 1,
          path: '/subject',
          label: '主科报告',
          auth: 'Exam-Gaokao-Report-Subject'
        })
      }
      this.routerKinds = list
    },
    getRoute (item) {
      const route = {
        path: '/exam/gaokao/report/' + this.examId + item.path,
        query: {
          reportType: item.reportType,
          newFlag: this.$route.query.newFlag,
          isRegion: this.isRegion
        }
      }
      if (item.reportType > 1) {
        route.query.type = this.examType
      }
      return route
    },
    initWaterMark () {
      if (sessionStorage.getItem('region-report-watermark') === '1') {
        watermark.init({
          watermark_txt:
            this.userInfo.nickName +
            "\n" +
            this.userInfo.loginName +
            "\n" +
            Util.formatDate(new Date()),
          watermark_color: "#e2e2e2", //水印字体颜色
          watermark_fontsize: "14px", //水印字体大小
          watermark_alpha: 0.5, //水印透明度，要求设置在大于等于0.005
          watermark_angle: 25, //水印倾斜度数
          watermark_width: 100, //水印宽度
          watermark_height: 100, //水印长度
          watermark_parent_node: "",
          monitor: false,
          show: true
        });
        watermark.load({
          show: true
        });
      }
    },
    exportData () {
      let method = 'checkExportTask'
      let params = {
        examId: this.examId,
        schoolId: this.userInfo.schoolId,
      }
      const self = this
      let list = this[this.categoryKey + 'Config']
      if (this.$route.query.newFlag + '' === 'false') {
        list = list.filter(s => !s.newVersion)
      }
      params.types = list.map(s => s.value)
      reportApi[method](params).then(res => {
        const paperReportData = []
        if (res.success) {
          let schoolAllReport = {}
          if (self.isClassReport) {
            for (let item in res.body) {
              if (item === self.categoryType) {
                schoolAllReport = res.body[item]
              } else {
                const schoolClass = {
                  classId: item,
                  ...res.body[item]
                }
                paperReportData.push(schoolClass)
              }
            }
          } else {
            schoolAllReport = res.body.find(s => s.category === self.categoryType)
            paperReportData.push(...res.body.filter(s => s.category !== self.categoryType))
          }

          self.schoolAllReport = schoolAllReport
          self.reportList = paperReportData;
        }
        self.$refs.exportModal.open()
      })
    },

    // 导出批阅报告
    createReadMarkExport (param) {
      const params = this.getExportParams(param.row)
      reportApi[`${param.type}ReportExport`](params).then(res => {
        if (res.success) {
          this.exportData()
        } else {
          this.$message.warning(res.message)
        }
      })
    },

    // 获取报告参数
    getExportParams (row) {
      return {
        id: row ? row.id : "",
        examId: this.examId,
        schoolId: this.userInfo.schoolId,
        module: "REPORT",
        paramModel: {
          examId: this.examId,
          schoolId: this.userInfo.schoolId,
          excludeProperties: [],
          type: row.category,
          param: '',
          async: true
        }
      }
    },
    // 设置
    pathToSetting () {
      const route = {
        path: '/exam/gaokao/setLevel',
        query: {
          examType: this.examType,
          examLineType: this.examLineType,
          levelExamId: this.examId,
          examName: this.examName,
          gradeId: this.gradeId,
          newFlag: this.$route.query.newFlag,
          update: 1,
          isRegion: this.isRegion
        }
      }
      this.$router.push(route)
    },

    async _getExam () {
      this.loading = true;
      let res = await getLevelExam(this.examId, this.isRegion);
      if (res.success) {
        this.subjectNames = res.body.subjectNames;
        this.examName = res.body.examName;
        this.gradeId = res.body.gradeId;
        this.isMore = res.body.isMore;
        this.isSplit = res.body.isSplit;
        this.examDate = Util.formatDate(res.body.createTime);
        this.examType = res.body.type;
        this.examLineType = exam_enum.getCodeByKey(res.body.levelExamLineSettingVos[0].type);

        let subjectList = [];
        const waiyus = ['28', '44', '46', '119', '52', '48', '67']
        const names = []
        for (let item of res.body.levelExamLineSettingVos) {
          const subjectName = waiyus.includes(item.subjectCode + '') ? '外语' : item.subjectName
          if (item.examId && !subjectList.find(s => s.subjectName === subjectName)) {
            names.push(item.subjectCode)
            const row = {
              id: item.id,
              subjectCode: item.subjectCode,
              subjectName: waiyus.includes(item.subjectCode + '') ? '外语' : item.subjectName
            }
            subjectList.push(row)
          }
        }

        if (this.examType === 1 || this.examType === 7) {
          const routes = xGaokao.getSubjectRouters(this.$route.query)
          // 物理
          if (names.filter(n => ['29', '55'].includes(n)).length > 0) {
            this.routerKinds.push({
              reportType: 2,
              parentPath: '/like',
              path: '/like' + routes[0].path,
              label: '物理类报告',
              auth: 'Exam-Gaokao-Report-like'
            })
          }
          // 历史
          if (names.filter(n => ['33', '60'].includes(n)).length > 0) {
            this.routerKinds.push({
              reportType: 3,
              parentPath: '/wenke',
              path: '/wenke' + routes[0].path,
              label: '历史类报告',
              auth: 'Exam-Gaokao-Report-wenke'
            })
          }
        }

        this.subjectList = subjectList;
        this.loading = false;
      } else {
        this.loading = false;
        this.$message.warning(res.message);
      }
    }
  }
};
</script>

<style scoped lang="scss">
.header {
  display: flex;
  height: 56px;
  line-height: 56px;
  font-size: 14px;
  color: #999999;

  .report-button {
    // margin-left: 25px;
    .menu-tab {
      display: inline-block;
      font-size: 14px;
      margin-right: 20px;
      padding: 0 15px;
      color: #333;
      line-height: 30px;
      font-weight: 500;
      border-radius: 20px;
      -webkit-transition: all 0.2s;
      transition: all 0.2s;
      cursor: pointer;
      height: 30px;
      text-align: center;
      background: rgba(229, 229, 229, 1);
      opacity: 1;
      border-radius: 15px;
    }

    .menu-tab.actived {
      background: $color-theme;
      color: #fff;
    }
  }

  .export-report {
    user-select: none;

    img {
      vertical-align: middle;
    }

    &:hover span {
      color: $color-theme;
      cursor: pointer;
    }
  }

  span {
    padding-left: 5px;
    vertical-align: middle;
  }
}

.info-wrapper {
  margin-top: 10px;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  height: 66px;
  line-height: 66px;
  background: #fff;
  box-shadow: $box-shadow;
  border-radius: 4px;
  padding: 0 15px;

  .back {
    position: relative;
    padding-right: 15px;
    cursor: pointer;

    img {
      vertical-align: middle;
    }

    span {
      vertical-align: middle;
    }

    &:hover span {
      color: $color-theme;
    }

    &::after {
      display: block;
      position: absolute;
      top: 16px;
      right: 0;
      content: " ";
      width: 1px;
      height: 36px;
      background-color: #e5e5e5;
    }
  }

  .info {
    position: relative;
    flex: 1;
    width: 0;
    display: flex;
    align-items: center;

    > h4 {
      margin: 0 15px;
      font-size: $font-size-large;
      font-weight: bold;
      color: $color-text;
    }

    .subject-list {
      margin-top: -6px;

      .tool-subject {
        display: inline-block;
        margin-right: 8px;
        width: 24px;
        height: 30px;
        line-height: 22px;
        text-align: center;
        font-size: 13px;
        color: #fff;
        background: url("~images/project.png") no-repeat;
        background-size: 24px 28px;
      }
    }

    .date {
      color: #999999;
      font-size: $font-size;

      img {
        padding: 0 5px;
        margin-top: -4px;
        vertical-align: middle;
      }
    }
  }

  .setting {
    display: flex;
    align-items: center;

    > img {
      width: 24px;
      height: 24px;
    }

    &:hover {
      cursor: pointer;
      opacity: 0.85;
    }
  }
}

.loading-bg {
  margin-top: 15px;
  background: #fff;
  height: calc(100vh - 310px);
  text-align: center;
  color: #777;
  font-size: 15px;
  box-shadow: $box-shadow;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
